<template>
  <div class="big-box" id="gallery">
    <div v-if="loading" id="loading">
      <VueLoading
        type="bars"
        color="#ffd169"
        :size="{ width: '80px', height: '80px' }"
      ></VueLoading>
    </div>
    <div v-else>
      <div class="gallery-item">
        <h1 class="gallery-title title">{{ gallery.title }}</h1>
        <h3 class="gallery-date body">{{ convertDate(gallery.date) }}</h3>
        <div class="gallery-image-section">
          <img
            :src="'https://po.cs.ui.ac.id/media/' + gallery.coverPhoto"
            class="cover-photo"
            alt=""
          />
        </div>
        <div class="gallery-content" v-html="gallery.content"></div>
      </div>
      <div class="container max-width row back-div">
        <router-link to="/gallery" class="container back">
          <img src="../assets/arrow.gif" id="back-icon" />
          <span class="body">Back to Gallery</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { convertDate } from "../utils/index";
import { constant } from "../const";
import { VueLoading } from "vue-loading-template";

export default {
  name: "GalleryDetail",
  components: {
    VueLoading
  },
  data() {
    return {
      gallery: {},
      loading: true
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      axios
        .post(constant.apiUrl, {
          query: `{
              activity(id:${this.$route.params.id}){
                id,
                title,
                date,
                coverPhoto,
                content
              }
            }`
        })
        .then(res => {
          var activity = res.data.data.activity;
          if (activity) {
            this.loading = false;
            this.gallery = {
              ...activity,
              content: activity.content
                .replace(/<img /, '<img style="max-width: 100%" height="auto"')
                .replace(
                  /src="\/media\/uploads\//,
                  'src="https://po.cs.ui.ac.id/media/uploads/'
                )
            };
          } else {
            this.$router.push({ name: "Gallery" });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    convertDate
  }
};
</script>

<style scoped>
#loading {
  padding: 20vh 0;
}

#gallery {
  background-color: #f1f1f1;
  min-height: 80vh;
  justify-content: flex-start;
  margin-top: 10vh;
  padding: 10vh 5vw;
  display: flex;
  flex-direction: column;
  width: calc(100% - 10vw);
}

.gallery-item {
  background-color: #d6e5ed;
  width: auto;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 10px 0px;
  padding: 10px 30px;
}

.gallery-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.gallery-title {
  margin-bottom: 5px;
}

.gallery-date {
  margin: 0px 0px 5px;
}

.gallery-image-section {
  width: 100%;
  align-items: center;
  margin: 2vh 0;
}

.cover-photo {
  width: 40vw;
  height: auto;
}

.gallery-content {
  margin-top: 0px;
  text-align: left;
  width: 100%;
}

.back-div {
  justify-content: flex-start;
}

.back {
  color: black;
}

.back:hover {
  color: #28587c;
}

#back-icon {
  transform: rotate(90deg);
  width: 70px;
  height: auto;
  margin-right: -10px;
}

@media screen and (max-width: 600px) {
  .cover-photo {
    width: 65vw;
  }

  #back-icon {
    width: 50px;
  }
}
</style>
